<div class="d-flex overflow-auto h-100 px-2 py-2 gap-2">
  <app-kanban-status-columns
    *ngFor="let state of process_states|| []; let index=index"
    [state] = state
  ></app-kanban-status-columns>
</div>
